import * as React from 'react';
import { CssBaseline, Container, Grid, Box } from '@material-ui/core';

import Header from 'components/Header/Header';
import { useStyles } from './styles';
import Copyright from 'components/Global/Copyright';
import Drawer from 'components/Drawer/Drawer';
import { ILayout } from 'types/Header/Layout';

const LayoutHome: React.FC<ILayout> = ({ children, drawerVisible, maxWidth, slider }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header drawerVisible={drawerVisible} />
      {drawerVisible && <Drawer slider={slider} />}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container disableGutters maxWidth={false}>
          <Grid container spacing={0} style={{ width: '100%' }}>
            {children}
          </Grid>
        </Container>
      </main>
    </div>
  );
};

export default LayoutHome;
